import type { ResumoBot } from '@/services/api/analytics-bot';
import { div, n, pct, usd } from '../format';

interface CardsReceitaProps {
    resumo: ResumoBot | undefined;
    rotulo: string;
    funisRastreados: { rastreados: number; total: number } | null;
    disparos: number | null;
}

/** Bloco Receita: total com a divisão flow/broadcast, flow, broadcast e cliques. */
export default function CardsReceita({ resumo, rotulo, funisRastreados, disparos }: CardsReceitaProps) {
    const r = resumo?.receita;
    const c = resumo?.cliques;
    const fFlow = div(r?.flow, r?.total);
    const fBroad = div(r?.broadcast, r?.total);
    const delta = r?.delta_pct;

    return (
        <div className="kpis">
            <div className="kpi" data-hero="1" style={{ ['--accent' as string]: 'var(--amber)' }}>
                <div className="eyebrow">Receita total do bot · {rotulo}</div>
                <div className="kpi-v num" style={{ color: 'var(--amber)' }}>{usd(r?.total)}</div>
                <div className="kpi-d">
                    {typeof delta === 'number' && Number.isFinite(delta) ? (
                        <>
                            <span className={delta >= 0 ? 'up' : 'down'}>
                                {delta >= 0 ? '▲' : '▼'} {pct(Math.abs(delta), 1)}
                            </span>{' '}
                            vs período anterior ({usd(r?.total_anterior)})
                        </>
                    ) : (
                        <span className="muted">sem comparação com o período anterior</span>
                    )}
                </div>
                <div className="split2">
                    {fFlow !== null && <i style={{ width: `${fFlow * 100}%`, background: 'var(--teal)' }} />}
                    {fBroad !== null && <i style={{ width: `${fBroad * 100}%`, background: 'var(--green)' }} />}
                </div>
            </div>

            <div className="kpi" style={{ ['--accent' as string]: 'var(--teal)' }}>
                <div className="eyebrow">Receita de flow · {rotulo}</div>
                <div className="kpi-v num" style={{ color: 'var(--teal)' }}>{usd(r?.flow)}</div>
                <div className="kpi-d">
                    {pct(fFlow === null ? null : fFlow * 100, 0)} do total
                    {funisRastreados && ` · ${funisRastreados.rastreados} de ${funisRastreados.total} funis rastreados`}
                </div>
            </div>

            <div className="kpi" style={{ ['--accent' as string]: 'var(--green)' }}>
                <div className="eyebrow">Receita de broadcast · {rotulo}</div>
                <div className="kpi-v num" style={{ color: 'var(--green)' }}>{usd(r?.broadcast)}</div>
                <div className="kpi-d">
                    {pct(fBroad === null ? null : fBroad * 100, 0)} do total
                    {disparos !== null && ` · ${n(disparos)} envios`}
                </div>
            </div>

            <div className="kpi" style={{ ['--accent' as string]: 'var(--blue)' }}>
                <div className="eyebrow">Cliques totais · {rotulo}</div>
                <div className="kpi-v num">{n(c?.total)}</div>
                <div className="kpi-d">{n(c?.flow)} em flow · {n(c?.broadcast)} em broadcast</div>
            </div>
        </div>
    );
}
